<template>
    <div id="detail-regular-user">
        <modal :backdrop="false" size="lg" v-model="modal">
            <div slot="header">
                <button @click.prevent="closeModal" class="close" type="button">x</button>
                <div class="row">
                    <div class="col-xs-6"><h4 class="smalltitle">Detail Regular User - {{ user.fullName }}</h4></div>
                </div>
            </div>
            <div class="modal-header with-nav">
                <ul class="nav nav-tabs">
                    <li class="tab-item" :class="(selectedTab === tab.value ? 'active': '') + ' tab-user'+ tab.value "
                        @click="selectTab(tab.value)" v-for="tab in listTab"><a href="javascript:void(0)">{{ tab.name
                        }}</a>
                    </li>
                    <li :class="{'wdropdown' : true , 'cur': isActiveEmrSetup }"
                        class="tab-item"
                        @mouseover="openEmrSetup = true"
                        @mouseleave="openEmrSetup = false"
                    >
                        <div class="dropdown">
                            <span class="header-item"><b>EMR Setup</b></span>
                            <div class="dropdown-content"
                                 v-bind:style='{"display" : (openEmrSetup ? "block" : "none" )}'>
                                <div class="header-item" @click="selectTab(10)">ID Proofing</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="content-tab">
                <tab-account-setting v-if="selectedTab === 1"
                                     :userInfo="userInfo"
                                     :payments="payments"
                                     :staffClinic="staffClinic"
                                     :addressBillings="addressBillings"
                                     :disabledForm="disabledForm"
                                     :checkingAccounts="checkingAccounts"></tab-account-setting>
                <tab-general-info
                        v-if="selectedTab === 2"
                        :userInfo="userInfo"
                        :profile="profile"
                        :disabledForm="disabledForm"
                >
                </tab-general-info>
                <tab-education
                        v-if="selectedTab === 3"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-education>
                <tab-demographic
                        v-if="selectedTab === 4"
                        :profile="profile"
                        :disabledForm="disabledForm"
                >
                </tab-demographic>
                <tab-insurance
                        v-if="selectedTab === 5"
                        :profile="profile"
                        :userInfo="userInfo"
                        :disabledForm="disabledForm"
                >
                </tab-insurance>
                <tab-license v-if="selectedTab === 6" :userInfo="userInfo"></tab-license>
                <tab-id-proofing v-if="selectedTab === 10" :userInfo="userInfo"></tab-id-proofing>
            </div>
            <div slot="footer">
                <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
            </div>
        </modal>
    </div>
</template>

<script>
import httpClient from '../../../client'
import DetailRegularUserMixin from '../../../mixins/user/UserStatusMixin.vue'
import TabAccountSetting from './tab-regular-user/TabAccountSetting.vue'
import TabGeneralInfo from './tab-regular-user/TabGeneralInfo.vue'
import TabEducation from './tab-regular-user/TabEducation.vue'
import TabDemographic from './tab-regular-user/TabDemographic.vue'
import TabInsurance from './tab-regular-user/TabInsurance.vue'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
import TabIdProofing from './tab-doctor/TabIdProofing.vue'
import TabLicense from './tab-regular-user/TabLicense.vue'
export default {
  name: 'DetailRegularUser',
  components: { TabAccountSetting, TabGeneralInfo, TabEducation, TabDemographic, TabInsurance, TabIdProofing, TabLicense },
  props: {
    user: {}
  },
  mixins: [DetailRegularUserMixin, CommonMixin],
  data () {
    return {
      modal: false,
      selectedTab: 1,
      listTab: [
        {
          name: 'Account Setting',
          value: 1
        },
        {
          name: 'General Info',
          value: 2
        },
        {
          name: 'Education',
          value: 3
        },
        {
          name: 'Demographic',
          value: 4
        },
        {
          name: 'Insurance',
          value: 5
        },
        {
          name: 'License',
          value: 6
        }
      ],

      userInfo: {},
      profile: {},
      payments: [],
      addressBillings: [],
      checkingAccounts: [],
      openEmrSetup: false,
      staffClinic: null
    }
  },
  computed: {
    disabledForm () {
      return true
    },
    isActiveEmrSetup () {
      return [10].indexOf(this.selectedTab) > -1
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getInfoAccount()
  },
  beforeDestroy () {
  },
  methods: {
    closeModal () {
      this.modal = false
    },
    selectTab (value) {
      this.selectedTab = Number(value)
    },
    async getInfoAccount () {
      try {
        let response = await httpClient.get('/users/detail-user/' + this.user.id + '?type=regularUser')
        if (response.data.s === 200) {
          this.userInfo = response.data.data.user
          let profile = JSON.parse(JSON.stringify(response.data.data.profile))
          //  profile.state = profile.stateCode ? profile.stateCode : profile.state
          this.profile = profile
          this.payments = response.data.data.payments
          this.addressBillings = response.data.data.addressBillings
          this.checkingAccounts = response.data.data.checkingAccounts
          this.staffClinic = response.data.data.staffClinic
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">
    .tab-item {
        cursor: pointer;
    }
</style>
<style scoped="">
    .tab-item {
        cursor: pointer;
    }
    .header-item {
        padding: 10px 15px;
        display: block;
    }
    .dropdown-content {
        left: 5px !important;
    }
    .tab-item:hover .dropdown > .header-item{
        background: #d9df20;
        color: #fff;
        border-color: #d9df20;
    }
    .tab-item.cur .dropdown > .header-item{
        background: #fff;
        color: #bec500;
    }
    .dropdown-content > .header-item:hover {
        color: #fff;
        background: #d9df20;
    }
</style>
